import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=cbe3ce76&"
import script from "./CompaniesTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports